var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-autobuyer-box__footer",on:{"click":_vm.emitClick}},[_c('label',{class:_vm.autobuyerStateClass},[_c('span',{class:_vm.autobuyerToggleClass})]),_c('input',{attrs:{"disabled":_vm.isDisabled,"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.isActive && !_vm.isDisabled}})])
}
var staticRenderFns = []

export { render, staticRenderFns }